import { render, staticRenderFns } from "./mode10.vue?vue&type=template&id=2f40fa34&scoped=true"
import script from "./mode10.vue?vue&type=script&lang=js"
export * from "./mode10.vue?vue&type=script&lang=js"
import style0 from "./mode10.vue?vue&type=style&index=0&id=2f40fa34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40fa34",
  null
  
)

export default component.exports